import { Grid } from "@mui/material";
import { useAppSelector, useDisplayedCollections } from "../../app/hooks";
import Error from "../common/Error";
import Loading from "../common/Loading";
import DatasetsCard from "./DatasetsCard";
import { Role } from "../../app/backendTypes";
import { useParams } from "react-router-dom";
import CollectionComponent from "./Collection";
import { SetCollection } from "./SetCollection";

export default function Datasets() {
  const { collections, loading, error, reload } = useDisplayedCollections();

  const isAdmin = useAppSelector((state) =>
    state.auth.roles.includes(Role.Administrator)
  );

  const params = useParams();
  const collection = collections.find((c) => c.id === params.id);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;
  if (collection !== undefined)
    return (
      <CollectionComponent
        displayedCollection={collection}
        callback={reload}
        isAdmin={isAdmin}
      />
    );

  return (
    <>
      {isAdmin && <SetCollection callback={reload} />}

      <Grid container spacing={4} justifyContent="center">
        {collections.map((datasets, i) => (
          <Grid size="auto" key={i}>
            <DatasetsCard displayedCollection={datasets} />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
